import  gql  from 'graphql-tag'

export const users = gql`query{
    users{
        edges{
            node{
            id
            username
            name
            surname
            email
            authSystem
            isActive
            group{
                id
                name
                permissions{
                    edges{
                        node{
                        id
                        name
                        }
                    }
                }
            }
            creditanalyst{
                office{
                    id
                    name
                    regional{
                        id
                    }
                }
                analystType{
                    id
                    name
                }
            }
            officedirector{
                office{
                    id
                    name
                    regional{
                        id
                    }
                }
            }
            regionaldirector{
                regional{
                    id
                    name
                }
            }
            }
        }
        }
    }`;